/**
 *
 * The start and expiry fields are Date.getTime()
 * number values.
 *
 * @param {number} start
 * @param {number} expiry
 * @returns
 */
export const getRemainingDays = (start, expiry) => {
  const differenceInMilliseconds = Math.abs(start - expiry)
  const millisecondsInADay = 24 * 60 * 60 * 1000
  const daysApart = differenceInMilliseconds / millisecondsInADay
  return Math.round(daysApart)
}

export const getRemainingDaysOnAssignment = (startDate, daysUntilExpired = 21) => {
  const now = new Date()
  const expiryDate = new Date(startDate)
  expiryDate.setDate(expiryDate.getDate() + daysUntilExpired)

  let remainingDays = (expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  if (remainingDays < 0) {
    remainingDays = 0
  } else {
    remainingDays = Math.round(remainingDays) || 1
  }
  return remainingDays
}

export const daysUntilExpiry = (startDate, daysUntilExpired = 21) => {
  const dateOfPurchase = new Date(startDate)
  const expiryDate = new Date()
  return getRemainingDays(dateOfPurchase.getTime(), expiryDate.getTime())
}
